import {OutlinedPillVariant} from '@forecast-it/design-system';
import {SaveState} from '../shared/saveState';

// What differs in the Studio's frame between a task agent and an agentic workflow: the save pill and
// version wording, the agent menu, whether a version name is required, how a failed save is shown and
// the tab spacing. The shell picks one variant per open agent, so the shared header, pill and version
// list read their wording from it instead of asking which kind of agent is open.
export interface NovaStudioVariant {
	saveStateLabelIds: Record<SaveState, string>;
	saveStateVariants: Record<SaveState, OutlinedPillVariant>;
	versionButtonLabelId: string;
	versionListTitleId: string;
	showAgentMenu: boolean;
	// The service refuses a save without a version name.
	requiresVersionName: boolean;
	// A failed save is shown as an alert with Retry above the tab, rather than by the pill alone.
	showsSaveErrorAlert: boolean;
	tabBarPadding: string;
	tabContentPadding: string;
}

const TASK_SAVE_STATE_VARIANTS: Record<SaveState, OutlinedPillVariant> = {
	[SaveState.Saved]: OutlinedPillVariant.SUCCESS,
	[SaveState.Saving]: OutlinedPillVariant.ACTIVE,
	[SaveState.Unsaved]: OutlinedPillVariant.NEUTRAL,
	[SaveState.Error]: OutlinedPillVariant.ERROR,
};

export const TASK_AGENT_VARIANT: NovaStudioVariant = {
	saveStateLabelIds: {
		[SaveState.Saved]: 'nova.saveState.saved',
		[SaveState.Saving]: 'nova.saveState.saving',
		[SaveState.Unsaved]: 'nova.saveState.unsaved',
		[SaveState.Error]: 'nova.saveState.error',
	},
	saveStateVariants: TASK_SAVE_STATE_VARIANTS,
	versionButtonLabelId: 'nova.studio.historyButton',
	versionListTitleId: 'nova.versionHistory.title',
	showAgentMenu: true,
	requiresVersionName: false,
	showsSaveErrorAlert: false,
	tabBarPadding: '8px 24px 0',
	tabContentPadding: '24px',
};

// A workflow's pill reads shorter, and an unsaved workflow shows as active rather than neutral. A
// workflow is one per binding, so it has no menu to duplicate or delete it.
export const WORKFLOW_VARIANT: NovaStudioVariant = {
	saveStateLabelIds: {
		[SaveState.Saved]: 'nova.saveState.saved',
		[SaveState.Saving]: 'nova.saveState.workflowSaving',
		[SaveState.Unsaved]: 'nova.saveState.workflowUnsaved',
		[SaveState.Error]: 'nova.saveState.workflowError',
	},
	saveStateVariants: {...TASK_SAVE_STATE_VARIANTS, [SaveState.Unsaved]: OutlinedPillVariant.ACTIVE},
	versionButtonLabelId: 'nova.studio.versionManagerButton',
	versionListTitleId: 'nova.versionHistory.managerTitle',
	showAgentMenu: false,
	requiresVersionName: true,
	showsSaveErrorAlert: true,
	tabBarPadding: '12px 24px 0',
	tabContentPadding: '20px 24px 44px',
};
